<template>
  <div class="versions">
    <div class="btn-box">
      <el-button class="add-btn" icon="el-icon-folder-opened" @click="exportPdf"
        >导出</el-button
      >
      <el-select
        v-model="language"
        placeholder="请选择导出语言"
        style="margin-left: 10px"
      >
        <el-option
          v-for="item in getDictDatas(DICT_TYPE.LANGUAGE)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>激活状态：</p>
          <el-select
            v-model="queryParams.activationStatus"
            placeholder="请选择激活状态"
          >
            <el-option
              v-for="item in activationStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="code" label="激活码"></el-table-column>
        <el-table-column prop="activationStatus" label="激活状态">
          <template slot-scope="{ row }">
            <p
              :style="{
                color:
                  Number(row.activationStatus) === 1 ? '#008000' : '#0000CD',
              }"
            >
              {{ row.activationStatus === 1 ? "已激活" : "未激活" }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="激活用户">
          <template slot-scope="{ row }">
            {{ row.nickName ? row.nickName : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="activationTime" label="激活时间">
          <template slot-scope="{ row }">
            {{ row.activationTime ? row.activationTime : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间"> </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import {
  getPageDeviceActivationCode,
  getActivationCodePdf,
} from "@/api/device";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        recordId: this.$route.query.id,
        activationStatus: "",
      },
      createTitle: this.$route.query.createTitle,
      // createdTime: "",
      tableData: [],
      total: 0, //总数
      activationStatusList: [
        { value: 0, label: "未激活" },
        { value: 1, label: "已激活" },
      ],
      language: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取设备激活码列表
    async init() {
      const res = await getPageDeviceActivationCode(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
      // this.createdTime = this.$moment(this.tableData[0].createdTime).format(
      //   "YYYY-MM-DD"
      // );
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.activationStatus = "";
      this.queryParams.pageNum = 1;
      this.init();
    },
    // 导出
    async exportPdf() {
      if (!this.language) {
        this.$message.error("请选择导出语言");
        return;
      }
      const res = await getActivationCodePdf(
        this.queryParams.recordId,
        this.language
      );
      // 处理响应数据
      const blob = new Blob([res], {
        type: "application/pdf",
      });

      // 获取文件名（从 headers 中提取，兼容中文名）
      let filename = `${this.createTitle}.pdf`;
      const disposition =
        res.headers?.["content-disposition"] ||
        res.headers?.get?.("content-disposition");
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?(.+)/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      // 生成下载链接
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // 清理资源
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
  },
};
</script>
<style lang="scss" scoped>
.versions {
  position: relative;
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
      // justify-content: space-around;
      > div {
        display: flex;
        align-items: center;
        padding-right: 20px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        // display: flex;
        // align-items: center;
        // margin-right: 24px;

        // .el-input {
        //   width: 180px;
        // }
        // input::-webkit-input-placeholder {
        //   /* WebKit browsers */
        //   color: rgba(0, 0, 0, 0.25);
        // }
        // .el-input__inner {
        //   background: #ffffff;
        //   border-radius: 4px;
        //   border: 1px solid #d9d9d9;
        // }
      }
    }
    .handlebox,
    .btnbox {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }
  .btn-box {
    position: absolute;
    top: -88px;
    right: 0;
    display: flex;
    align-items: center;
    .total-box {
      display: flex;
      align-items: center;
      margin-right: 90px;
      p {
        font-size: 16px;
        display: flex;
        align-items: flex-end;
        margin-right: 40px;
        span {
          display: inline-block;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  ::v-deep .demo-activationForm {
    width: 80%;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px !important;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      text-align: right;
    }
    .el-form-item__content {
      width: 0;
      flex: 1;
      margin: 0 !important;
    }
    .handlebox {
      text-align: right;
      margin-top: 50px;
    }
    // .el-input {
    //   width: 380px;
    // }
  }
  .textOrange-btn {
    padding: 0 5px;
  }
}
</style>
